import React, { MouseEventHandler } from 'react';

type SvgProp = MouseEventHandler<SVGSVGElement> | undefined;

type IconProps<T extends SvgProp, B> = {
  handler?: T;
  options?: B;
};

const Icons = {
  clock: <T extends SvgProp, B>({ handler, options }: IconProps<T, B>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 237.54 237.54"
        fill="#000C37"
        onClick={handler}
        {...options}
      >
        <g>
          <path
            d="M118.77,0c32.8,0,62.49,13.29,83.98,34.79c21.49,21.49,34.79,51.19,34.79,83.98s-13.29,62.49-34.79,83.98 c-21.49,21.49-51.19,34.79-83.98,34.79c-32.8,0-62.49-13.29-83.98-34.79C13.29,181.26,0,151.56,0,118.77s13.29-62.49,34.79-83.98 C56.28,13.29,85.97,0,118.77,0L118.77,0z M109.06,60.2c0-3.59,2.91-6.5,6.5-6.5s6.5,2.91,6.5,6.5v60l45.14,26.76 c3.08,1.82,4.11,5.8,2.29,8.89c-1.82,3.08-5.8,4.11-8.89,2.29l-47.99-28.45c-2.11-1.08-3.55-3.27-3.55-5.79V60.2L109.06,60.2z M193.56,43.98C174.42,24.84,147.98,13,118.77,13c-29.21,0-55.65,11.84-74.79,30.98C24.84,63.12,13,89.56,13,118.77 c0,29.21,11.84,55.65,30.98,74.79c19.14,19.14,45.58,30.98,74.79,30.98c29.21,0,55.65-11.84,74.79-30.98 c19.14-19.14,30.98-45.58,30.98-74.79C224.54,89.56,212.7,63.12,193.56,43.98L193.56,43.98z"
            fill="currentColor"  
          />
        </g>
      </svg>
    );
  },
  eye: <T extends SvgProp, B>({ handler, options }: IconProps<T, B>) => {
    return (
      <svg
        className="post__statistics-icon"
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="eye"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        fill="#000C37"
        onClick={handler}
        {...options}
      >
        <path
          fill="currentColor"
          d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
        />
      </svg>
    );
  },
  heart: <T extends SvgProp, B>({ handler, options }: IconProps<T, B>) => {
    return (
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="heart"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        fill="#000C37"
        onClick={handler}
        {...options}
      >
        <path
          d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
          fill="currentColor"  
        />
      </svg>
    );
  },
  facebook: <T extends SvgProp, B>({ handler, options }: IconProps<T, B>) => {
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 50 50" 
        width="20px" 
        height="20px" 
        fill="#ffffff"
        color="#000c37"
        onClick={handler}
        {...options}
      >
        <path 
          d="M32,11h5c0.552,0,1-0.448,1-1V3.263c0-0.524-0.403-0.96-0.925-0.997C35.484,2.153,32.376,2,30.141,2C24,2,20,5.68,20,12.368 V19h-7c-0.552,0-1,0.448-1,1v7c0,0.552,0.448,1,1,1h7v19c0,0.552,0.448,1,1,1h7c0.552,0,1-0.448,1-1V28h7.222 c0.51,0,0.938-0.383,0.994-0.89l0.778-7C38.06,19.518,37.596,19,37,19h-8v-5C29,12.343,30.343,11,32,11z"
          fill="currentColor"
        />
      </svg>
    );
  },
  x: <T extends SvgProp, B>({ handler, options }: IconProps<T, B>) => {
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg"
        width="21" 
        height="22" 
        viewBox="0 0 16 17" 
        fill="#000C37" 
        onClick={handler}
        {...options}
      >
        <g clipPath="url(#clip0_13673_43731)">
          <path
            d="M12.1606 2.2088H14.3669L9.54813 7.71505L15.2169 15.2088H10.7794L7.30126 10.6651L3.32626 15.2088H1.11688L6.27001 9.31818L0.835632 2.2088H5.38563L8.52626 6.36193L12.1606 2.2088ZM11.3856 13.8901H12.6075L4.72001 3.4588H3.40751L11.3856 13.8901Z"
            fill="#currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_13673_43731">
            <rect width="16" height="16" fill="white" transform="translate(-0.00189209 0.708801)"/>
          </clipPath>
        </defs>
      </svg>
    );
  },
  linkedin: <T extends SvgProp, B>({ handler, options }: IconProps<T, B>) => {
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 30 30" 
        width="24px" 
        height="24px" 
        fill="#ffffff"
        color="#000c37"
        onClick={handler}
        {...options}
      >
        <path 
          fill="currentColor"
          d="M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065 c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z"
        />
      </svg>
    );
  },
};

export { Icons };